export class RequestFailedError extends Error {}
